import Info from './Info.vue';

export default Info;



// WEBPACK FOOTER //
// ./src/pages/profile/views/settings/components/info/index.ts